<template>
  <div class="admin-orders-grouped">
    <header-title :title="title"></header-title>
    <div class="admin-categories">
      <div class="category-btn">
        <v-btn
          @click="openReprintDialog()"
          class="notification-button reprint-btn printer-btn"
          dark
          text
        >
          <img width="25" src="@/assets/images/printer_icon.png" alt="Print" />
          <span
            class="total-quantity"
            :class="printingErrorsPresent ? 'errors-red' : 'errors-green'"
          >
            {{ totalPrintingErrors }}
          </span>
        </v-btn>
      </div>
    </div>

    <OrdersGrouped :group-order-id="id" :orders="ordersGrouped"></OrdersGrouped>
    <reprint-dialog :group-order-id="id" ref="reprintDialogRef" />
  </div>
</template>

<script>
import { categoriesCollection } from "@/collections/categories";
import OrdersGrouped from "@/components/admin/order/OrdersGrouped";
import ReprintDialog from "@/components/admin/printer/ReprintDialog.vue";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { printerErrorsCollection } from "@/collections/printerErrors";
import { ordersCollection } from "@/collections/orders";
import { groupOrdersCollection } from "@/collections/groupOrders";

export default {
  name: "OrdersGroup",
  props: ["id"],
  components: {
    OrdersGrouped,
    ReprintDialog,
    HeaderTitle
  },
  data() {
    return {
      orders: [],
      groupOrders: [],
      categories: [],
      printerErrors: []
    };
  },
  firestore() {
    return {
      orders: ordersCollection
        .where("isPending", "==", true)
        .orderBy("time", "asc"),
      categories: categoriesCollection,
      groupOrders: groupOrdersCollection,
      printerErrors: printerErrorsCollection
        .where("status", "==", true)
        .where("groupId", "==", this.id)
    };
  },
  computed: {
    title() {
      let groupOrder = this.groupOrders.find(x => x.id === this.id);
      return groupOrder ? groupOrder.name : "";
    },
    ordersGrouped() {
      if (this.groupOrders && this.categories && this.orders) {
        let orders = this.orders;
        let allMenuGroupItem = [];
        let menuGroup = this.orders.filter(item => {
          if (item.isMenuGroupProduct) {
            return item;
          }
        });

        menuGroup.forEach(item => {
          if (item.isMenuGroupProduct) {
            item.starters = item.starters.map(x => {
              x.menu_group_id = item.id;
              x.quantity = item.quantity;
              x.time = item.time;
              x.size = item.size;
              x.notes = item.notes;
              x.fcmToken = item.fcmToken;
              x.tableQR = item.tableQR;
              return x;
            });
            item.maincourse = item.maincourse.map(x => {
              x.menu_group_id = item.id;
              x.quantity = item.quantity;
              x.time = item.time;
              x.size = item.size;
              x.notes = item.notes;
              x.fcmToken = item.fcmToken;
              x.tableQR = item.tableQR;
              return x;
            });
            item.desserts = item.desserts.map(x => {
              x.menu_group_id = item.id;
              x.quantity = item.quantity;
              x.time = item.time;
              x.size = item.size;
              x.notes = item.notes;
              x.fcmToken = item.fcmToken;
              x.tableQR = item.tableQR;
              return x;
            });
            item.drinks = item.drinks.map(x => {
              x.menu_group_id = item.id;
              x.quantity = item.quantity;
              x.time = item.time;
              x.size = item.size;
              x.notes = item.notes;
              x.fcmToken = item.fcmToken;
              x.tableQR = item.tableQR;
              return x;
            });
            allMenuGroupItem = [
              ...allMenuGroupItem,
              ...item.starters,
              ...item.maincourse,
              ...item.desserts,
              ...item.drinks
            ];
          }
        });

        let menuGroupCat = [];
        allMenuGroupItem.forEach(item => {
          let findCategory = this.categories.find(
            cat => item.category_id === cat.id
          );
          if (findCategory && findCategory.group_order_id === this.id) {
            menuGroupCat.push(findCategory.id);
          }
        });

        let filterItem = allMenuGroupItem.filter(item =>
          menuGroupCat.includes(item.category_id)
        );

        let categories = [];
        this.categories.forEach(c => {
          if (c.group_order_id === this.id) {
            categories.push(c.id);
          }
        });
        orders = orders.filter(o => categories.includes(o.category_id));
        let allOrder = [...orders, ...filterItem];
        return this.arrayGroupBy(allOrder, "tableQR");
      }
      return [];
    },
    printingErrorsPresent() {
      return !!(this.printerErrors && this.printerErrors.length);
    },
    totalPrintingErrors() {
      if (this.printerErrors && this.printerErrors.length > 9) {
        return "+9";
      } else if (this.printerErrors && this.printerErrors.length) {
        return this.printerErrors.length;
      } else {
        return "";
      }
    }
  },
  methods: {
    openReprintDialog() {
      if (this.printingErrorsPresent) {
        this.$refs.reprintDialogRef.open();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.errors-red {
  background: #ff5252 !important;
}

.errors-green {
  background: #4caf50 !important;
}

.reprint-btn {
  width: 70px;
  height: 46px !important;
  min-width: 70px !important;
  border: 2px solid lightgray;
  background-color: white !important;
  border-radius: 0;
}

.total-quantity {
  position: absolute;
  width: 25px;
  height: 25px;
  top: -20px;
  right: -30px;
  border-radius: 50%;
  background: #ff5252;
  color: #fff;
  font-size: 12px;
  line-height: 25px;
  text-align: center;
}
</style>
